import React, { useEffect, useState, memo } from 'react';
import styled from '@emotion/styled';
import XLoader from '@nexus/lib-react/dist/core/Loading/XLoader';

const Wrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  position: absolute;
  z-index: 9999;
`;

const CenterContainer = styled.div`
  margin: auto;
  margin-top: calc(100% - 90px);
`;

const spinner = (
  <Wrapper>
    <CenterContainer data-testid="x-loader">
      <XLoader />
    </CenterContainer>
  </Wrapper>
);

function LoadingSpinner({ delay = 0 }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      setShow(true);
    }, delay);
    return () => clearTimeout(id);
  }, [delay]);

  return show ? spinner : null;
}

export default memo(LoadingSpinner);
